var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailPreferencesIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.18018 17.1501C2.73852 17.1501 2.37005 17.001 2.07476 16.7027C1.77946 16.4044 1.6315 16.0318 1.63086 15.585V5.15595C1.63086 4.70979 1.77882 4.33755 2.07476 4.03925C2.37069 3.74094 2.73884 3.59147 3.17922 3.59082H17.3398C17.7808 3.59082 18.149 3.7403 18.4443 4.03925C18.7395 4.3382 18.8875 4.71043 18.8882 5.15595V15.586C18.8882 16.0315 18.7402 16.4037 18.4443 16.7027C18.1483 17.0016 17.7802 17.1508 17.3398 17.1501H3.18018ZM10.2595 10.4828L2.5896 5.41648V15.586C2.5896 15.7596 2.64489 15.9023 2.75546 16.014C2.86603 16.1257 3.00761 16.1816 3.18018 16.1816H17.3398C17.5117 16.1816 17.653 16.1257 17.7636 16.014C17.8741 15.9023 17.9294 15.7593 17.9294 15.585V5.41551L10.2595 10.4828ZM10.2595 9.40195L17.6341 4.55934H2.88489L10.2595 9.40195ZM2.5896 5.41648V4.55934V15.586C2.5896 15.7596 2.64489 15.9023 2.75546 16.014C2.86603 16.1257 3.00761 16.1816 3.18018 16.1816H2.5896V5.41648Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailPreferencesIcon);
export default __webpack_public_path__ + "static/media/mailPreferencesIcon.02f8e48e73cdd3a0dc03910fc8feb835.svg";
export { ForwardRef as ReactComponent };